import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Scenery = () => {
  return (
    <React.Fragment>
      <SEO title="风景名胜 | ICSI 2022" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="风景名胜"
        content="For Participants"
        contentTwo="风景名胜"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content2">
        <div className="ch-lang-ch">
          <Link className="btn btn-primary btn-hover-secondary  mt-s" to={process.env.PUBLIC_URL + "/scenery"}>English</Link>
          </div>
          <div className="space-50"></div>

          <h2>西安的风景名胜</h2>
          <p align="justify">
            <b>
              西安市古称“长安”、“京兆”，在《史记》中被誉为“金城千里，天府之国”，是举世闻名的世界四大古都之一。西安的旅游资源得天独厚，为著名的世界历史文化名城之一。西安是中国古代文明的重要摇篮之一，有着3000年的建城史；先后有13个王朝在西安建都。这里曾经是中国政治、经济、文化的中心，大汉时期的首都，汉文化发源地。“丝绸之路”就是以当时的长安，现在的西安为起点。西安是与雅典、罗马、开罗齐名的世界著名历史古都。1981年联合国教科文组织授予西安“世界历史名城”称号。
              <br />
              西安文化遗产极为丰富。西安市境内有全国重点文物保护单位34处，陕西省文物保护单位72处，市县级重点文物保护单位176处。西安是首批获得“中国优秀旅游城市”称号的地区，旅游业是西安经济发展的支柱产业以及非外贸创汇的主要来源。西安是中华即汉文化发源地，西周古都，周幽王烽火戏诸侯的烽火台、汉长安城、汉王宫遗址、汉高祖刘邦长陵、汉景帝阳陵等诸多汉王陵、汉武帝茂陵、武周女王武则天乾陵及诸多汉墓群。西安事变发生地。
              此外，西安还有终南山脉等著名的自然风景区，以及古时流传下来的“长安八景”。
              <br />
            </b>
            <br />
          </p>

          <li>
            <a href="#bingmayong">秦始皇兵马俑博物馆</a>
          </li>
          <li>
            <a href="#huaqing">华清池景区</a>
          </li>
          <li>
            <a href="#dayanta">大雁塔·大唐芙蓉园景区</a>
          </li>
          <li>
            <a href="#daminggong">大明宫国家遗址公园</a>
          </li>
          <li>
            <a href="#chengqiang">
            西安城墙-碑林历史文化景区
            </a>
          </li>
          <li>
            <a href="#zhonggulou">西安钟鼓楼</a>
          </li>
          <li>
            <a href="#chenghuangmiao">西安城隍庙</a>
          </li>
          <br />
          <h4 id="bingbayong">秦始皇兵马俑博物馆</h4>
          <p align="justify">
            秦始皇兵马俑博物馆位于陕西省西安市临潼区秦陵镇，成立于1975年，是以秦始皇兵马俑为基础，在兵马俑坑原址上建立的遗址类博物馆，是中国较大的古代军事博物馆。秦始皇兵马俑，是世界文化遗产，兵马俑的发现被誉为世界第八大奇迹、二十世纪考古史上的伟大发现。秦始皇兵马俑博物馆共有一、二、三号3个兵马俑坑，埋藏着大量陶俑、陶马、青铜兵器等。
          </p>
          <p>
            <b>地址：</b>陕西省西安市临潼区秦陵北路
          </p>
          <p>
            <img
              src="./images/xian/sc1.jpg"
              alt="秦始皇兵马俑博物馆"
              width="100%"
              />
          </p>

          <h4 id="huaqing">华清池景区</h4>
          <p align="justify">
            西安市华清池景区位于西安城东30公里，于2015年1月与&quot;骊山&quot;两大景区合并升级为华清宫，是中国唐文化旅游标志性景区，也是全国重点风景名胜区、全国重点文物保护单位、国家级文化产业示范基地。华清宫内集中着唐御汤遗址博物馆、西安事变旧址--五间厅、唐梨园遗址博物馆等文化区和飞霜殿、环园和禹王殿等标志性建筑群。骊山海拔1302米，老母殿、老君殿、烽火台、遇仙桥等景点星罗棋布，“骊山晚照”是著名的“关中八景”之一。
          </p>
              <p>
                <b>地址：</b>陕西省西安市临潼区华清路38号
              </p>
          <p>
            <img
              src="./images/xian/sc2.jpg"
              alt="西安市华清池景区"
              width="100%"
              />
            <br />
          </p>

          <h4 id="dayanta">大雁塔·大唐芙蓉园景区 </h4>
          <p align="justify">
          陕西西安大雁塔·大唐芙蓉园景区包含大雁塔、大唐芙蓉园两个旅游区，大唐芙蓉园位于陕西省西安市城南的曲江开发区，大雁塔东南侧，是一个全方位展示盛唐风貌的大型皇家园林式文化主题公园，占地面积一千亩，其中水域面积三百亩。而大雁塔位于陕西省西安市南的大慈恩寺内，又名“慈恩寺塔”，七层塔身，通高64.517米，底层边长25.5米。大雁塔的修建，是佛塔这种古印度佛教的建筑形式随着佛教传播而传入中国的结果


          </p>
              <p>
                <b>地址：</b>陕西省西安市雁塔区
              </p>
          <p>
            <img
              src="./images/xian/sc3.jpg"
              alt="陕西西安大雁塔"
              width="100%"
              />
            <img
              src="./images/xian/sc4.jpg"
              alt="大唐芙蓉园景区"
              width="100%"
              />
            <br />
          </p>

          <h4 id="daminggong">大明宫国家遗址公园 </h4>
          <p align="justify">
          大明宫国家遗址公园位于陕西省西安市太华南路，大明宫地处长安城北部的龙首原上，始建于唐太宗贞观八年，平面略呈梯形。唐大明宫占地3.5平方公里，其面积相当于3个凡尔赛宫、4.5个故宫、12个克里姆林宫、13个卢浮宫、15个白金汉宫，充分显示了唐代宫城建筑的雄伟风貌。大明宫遗址是1961年国务院公布的首批全国重点文物保护单位，是国际古遗址理事会确定的具有世界意义的重大遗址保护工程，是丝绸之路整体申请世界文化遗产的重要组成部分。
          </p>
              <p>
                <b>地址：</b>陕西省西安市新城区自强东路585号
              </p>

          <p>
            <img
              src="./images/xian/sc5.jpg"
              alt="大明宫国家遗址公园"
              width="100%"
              />
            <br />
          </p>

          <h4 id="chengqiang">
          西安城墙-碑林历史文化景区
          </h4>
          <p align="justify">
          城墙-碑林历史文化景区是由西安市最有影响力的碑林博物馆和城墙景区组成，西安碑林博物馆紧邻书院门文化街，以收藏、陈列和研究历代碑刻、墓志和石刻闻名于世。西安城墙，这座世界上历史最悠久、保存最完整的古代城垣建筑，延续了整个古都长安的历史文脉，并以其独特的魅力向世人绽放着她的恢弘、壮丽和博大，向世界展示着古都的深邃、智慧和兼容并蓄。
          </p>
            <p>
              <b>地址：</b>陕西省西安市临潼县区
            </p>
          <p>
            <img
              src="./images/xian/sc6.jpg"
              alt="西安城墙景区"
              width="100%"
              />
            <img
              src="./images/xian/sc7.jpg"
              alt="碑林历史文化景区"
              width="100%"
              />
            <br />
          </p>

          <h4 id="zhonggulou">西安钟鼓楼</h4>
          <p align="justify">
          西安钟鼓楼是西安钟楼和西安鼓楼的合称，位于西安市中心，是西安的标志性建筑物，两座明代建筑遥相呼应，蔚为壮观。西安钟楼始建于明洪武十七年（公元1384年），原建于今西大街北广济街东侧，明万历十年（公元1582年）移于现址。钟楼是一座重檐三滴水式四角攒尖顶的阁楼式建筑，面积1377.64平方米，建在用青砖、白灰砌成的方形基座上。基座下有高与宽均为6米的十字形券洞与东南西北四条大街相通。西安鼓楼始建于明洪武十三年（公元1380年），比钟楼的建造时间稍早。鼓楼建于高大的长方形台基之上，台基下辟有高和宽均为6米的南北向券洞
          </p>
              <p>
                <b>地址：</b>陕西省西安市临潼县区
              </p>
          <p>
            <img
              src="./images/xian/sc8.jpg"
              alt="西安钟鼓楼"
              width="100%"
              />
            <br />
          </p>

          <h4 id="chenghuangmiao">西安城隍庙 </h4>
          <p align="justify">
          西安城隍庙是天下三大“都城隍庙”之一，与北京、南京城隍庙齐名。原主要建筑有大门、玉皇阁、乐舞楼、牌楼、大殿、道舍、厢房等，后大多被毁，现仅存有清雍正元年(1723)重修大殿一座，斗拱出檐，雄伟状观，顶覆琉璃瓦，前檐格扇门窗浮雕各种图案花纹，雕工精细，图案精美，殿内原塑立有城隍、判官、小鬼等像。庙外牌坊前原置立铜狮一对，均为明嘉靖三十八年(1559)所铸造，现置陕西省博物馆大门外。是庙乃西安著名的古道教庙宇和商贾百工技艺云集之地。2001年06月25日，西安都城隍庙作为明、清时期古建筑，被国务院批准列入第五批全国重点文物保护单位名单。
          </p>
            <p>
              <b>地址：</b>陕西省西安市莲湖区西大街129号
            </p>
          <p>
            <img
              src="./images/xian/sc9.jpg"
              alt="西安城隍庙"
              width="100%"
              />
            <br />
          </p>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Scenery;
